import React from "react";
import {makeStyles, tokens} from "@fluentui/react-components";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        scrollbarColor: `${tokens.colorNeutralForeground3} transparent`,
        "::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
        },
        "::-webkit-scrollbar-thumb": {
            backgroundColor: tokens.colorNeutralForeground3,
            borderRadius: tokens.borderRadiusMedium,
        },
        "::-webkit-scrollbar-thumb:hover": {
            backgroundColor: tokens.colorNeutralForeground2,
        },
    },
});

interface PageProps {
    children: React.ReactNode;
}

export default function Page({children}: Readonly<PageProps>) {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            {children}
        </div>
    );
}